import React from 'react';

const Modal = ({ visible, name, description, startDate, endDate, location, onClose }) => visible ? (
  <div className="sc__modal">
    <div className="sc__modal__content">
      <button className="sc__modal__close" onClick={onClose}>
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="1" y1="-1" x2="22.2646" y2="-1" transform="translate(0.616211 2.00001) scale(0.92965 1.06572) rotate(45)" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="1" y1="-1" x2="22.2646" y2="-1" transform="translate(2.31543 19.5316) scale(0.92965 1.06572) rotate(-45)" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h2>{name}</h2>
      <p className="sc__modal__time">{startDate} - {endDate}</p>
      <p className="sc__modal__location">{location}</p>
      <p>{description}</p>
    </div>
  </div>
) : null;

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Schedule/ScheduleComponent/Modal.jsx